import React from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faCreditCard, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import "./style.css";

const stepRoutes = [
  "/orderdomain",
  "/orderhosting",
  "/orderemailsuite",
  "/ordervps",
  "/orderserver",
  "/orderssl",
  "/ordersignature",
  "/orderproduct",
  "/orderobjectstorage",
  "/orderdiegovpn",
  "/orderdomainbackorder",
  "/migrasihosting",
  "/upgrade"
];

const ProgressBar = () => {
  const location = useLocation();
  let percent = 0;

  if (stepRoutes.includes(location.pathname)) {
    percent = 0;
  } else if (location.pathname === "/paymentmethod") {
    percent = 50;
  } else if (location.pathname === "/ordersummary") {
    percent = 100;
  }
  
  return (
    <div className="order-progressbar-wrapper">
      <div className="container-fluid px-3 px-lg-4">
        <div className="order-progressbar-label d-flex justify-content-between">
          <div className="progress-label-item">
            <span className={`progress-label-text ${percent >= 0 ? "fw-bold" : ""}`}>
              <FontAwesomeIcon icon={faShoppingCart} className="progress-icon" />
              <span className="progress-label-text-content">Pilih Produk</span>
            </span>
          </div>
          <div className="progress-label-item">
            <span className={`progress-label-text ${percent >= 50 ? "fw-bold" : ""}`}>
              <FontAwesomeIcon icon={faCreditCard} className="progress-icon" />
              <span className="progress-label-text-content">Pilih Metode Pembayaran</span>
            </span>
          </div>
          <div className="progress-label-item">
            <span className={`progress-label-text ${percent === 100 ? "fw-bold" : ""}`}>
              <FontAwesomeIcon icon={faCheckCircle} className="progress-icon" />
              <span className="progress-label-text-content">Selesai</span>
            </span>
          </div>
        </div>
        <div className="order-progressbar-steps">
          <div className={`progress-step ${percent >= 0 ? "active" : ""} ${percent > 0 ? "done" : ""}`}>
            {percent > 0 ? (
              <FontAwesomeIcon icon={faCheckCircle} className="progress-step-icon" />
            ) : (
              "1"
            )}
          </div>
          <div className={`progress-line ${percent >= 50 ? "active" : ""}`}></div>
          <div className={`progress-step ${percent >= 50 ? "active" : ""} ${percent === 100 ? "done" : ""}`}>
            {percent === 100 ? (
              <FontAwesomeIcon icon={faCheckCircle} className="progress-step-icon" />
            ) : (
              "2"
            )}
          </div>
          <div className={`progress-line ${percent === 100 ? "active" : ""}`}></div>
          <div className={`progress-step ${percent === 100 ? "active" : ""} ${percent === 100 ? "done" : ""}`}>
            {percent === 100 ? (
              <FontAwesomeIcon icon={faCheckCircle} className="progress-step-icon" />
            ) : (
              "3"
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
